import { DatePicker, Row, Col } from 'antd';
import { useMachineFilter } from 'hooks/useMachineFilter';
import PropType from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatRangePickerDate } from 'util/date';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';

export const CleaningReportFilter = ({ filters = {}, onChange }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.CLEANING_REPORT);
  const { RangePicker } = DatePicker;
  const { startDate, endDate, ...machineFilter } = filters;
  const [MachineFilter, machineFilterState] = useMachineFilter(machineFilter);
  const [crFilterState, setCrFilterState] = useState(filters);

  const onChangeDate = useCallback(
    (dates) => {
      const [startDateValue, endDateValue] = dates || [];
      const updatedState = {
        ...crFilterState,
        startDate: formatRangePickerDate(startDateValue),
        endDate: formatRangePickerDate(endDateValue)
      };
      setCrFilterState(updatedState);
      onChange(updatedState);
    },
    [crFilterState, onChange]
  );

  useEffect(() => {
    if (
      machineFilterState.facility !== crFilterState.facility ||
      machineFilterState.object !== crFilterState.object ||
      machineFilterState.machineId !== crFilterState.machineId
    ) {
      const newState = { ...crFilterState, ...machineFilterState };
      setCrFilterState(newState);
      onChange(newState);
    }
  }, [machineFilterState, onChange, crFilterState]);

  return (
    <Row gutter={[12, 12]} className="cleaning-filter">
      <Col>
        <MachineFilter defaultState={machineFilter} />
      </Col>
      <Col>
        <h5>{t('filter.period')}</h5>
        <RangePicker className="custom-picker" onChange={onChangeDate} />
      </Col>
    </Row>
  );
};

CleaningReportFilter.propTypes = {
  filters: PropType.shape().isRequired,
  onChange: PropType.func.isRequired
};
